import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const DiscussionSection = ({
  title = <><span className="text-primary">Need a Scan to</span> BIM Quote for Your USA Project?</>,
  subtitle = "Send us your point cloud files, sample scans, project location, and required deliverables. We will review your scope and share a customized quotation with timeline and modeling approach.",
  buttonText = "Book a Free Consultation"
}) => {
  return (
    <section className="discussion-section">
      <div className="discussion-content">
        <h2 className="discussion-title">
          {title}
        </h2>
        <p className="discussion-subtitle">
          {subtitle}
        </p>
        <button className="discussion-btn">
          {buttonText} <ArrowUpRight size={18} className="btn-arrow" />
        </button>
      </div>
    </section>
  );
};

export default DiscussionSection;
